export const LeadsManageAction = {
  CALL: 'CALL',
  UPDATE_SINGLE_LEADS: 'UPDATE_SINGLE_LEADS', // 单条线索数据发生更新
};
